/* app/js/src/components/common/switchToggle/switchToggle.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  cursor: pointer;
  border: 1px solid black;
  height: 2em;
  width: 4em;
  display: block;
  background-color: #ffffff;
  border: 1px solid #c6d2df;
  border-radius: 1.5em;
  position: relative;
}
div > span {
  display: block;
  height: 2.2em;
  width: 2.3em;
  background-color: #ffffff;
  border-radius: 1.5em;
  border: 1px solid #c6d2df;
  cursor: pointer;
  -ms-transform: translate(-0.2em, -0.2em);
  -webkit-transform: translate(-0.2em, -0.2em);
  transform: translate(-0.2em, -0.2em);
  -webkit-box-shadow: 0.7px 0.7px 3px 0 rgba(35, 47, 58, 0.17);
  -moz-box-shadow: 0.7px 0.7px 3px 0 rgba(35, 47, 58, 0.17);
  box-shadow: 0.7px 0.7px 3px 0 rgba(35, 47, 58, 0.17);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div > span:active {
  -webkit-box-shadow: 0px 0px 3px 0 rgba(35, 47, 58, 0.05);
  -moz-box-shadow: 0px 0px 3px 0 rgba(35, 47, 58, 0.05);
  box-shadow: 0px 0px 3px 0 rgba(35, 47, 58, 0.05);
}
div.active {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  background-color: #61b965;
}
div.active > span {
  -ms-transform: translate(1.7em, -0.2em);
  -webkit-transform: translate(1.7em, -0.2em);
  transform: translate(1.7em, -0.2em);
}
div.black {
  border: 0 !important;
}
div.black:not(.active) {
  background-color: #141b22;
}
div.black span {
  border: 0;
  background-color: #4d5761;
}
/*# sourceMappingURL=switchToggle.component.css.map */
